var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-skeleton-loader",
    {
      staticClass: "dashboard-component",
      attrs: {
        transition: "scale-transition",
        type: "image",
        height: "290",
        loading: _vm.isLoading
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "pull-up" },
        [
          _c("v-card-title", { staticClass: "overline d-flex justify-start" }, [
            _c("h3", [_vm._v("Resumen del mes")])
          ]),
          _c(
            "v-card-text",
            {
              staticClass: "d-flex justify-center",
              attrs: { collapse: "", show: "" }
            },
            [
              _c("apexchart", {
                staticClass: "dashboard-chart",
                attrs: {
                  type: _vm.chartType,
                  options: _vm.summaryChartOptions,
                  series: _vm.currentSeries
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }